export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:3005/api" //"https://gop-backend-7201333562ee.herokuapp.com/api";
export const ENVIRONMENT = process.env.ENVIRONMENT || "development";
console.log("BACKEND_URL", BACKEND_URL);
console.log("ENVIRONMENT", ENVIRONMENT);
